import React from 'react';
import PropTypes from 'prop-types';

import { Container, Links, Logo, LogoContainer, TextContainer } from './styles';

/**
 * Footer beneath the LeftNav: "powered by Decisiv" mark, copyright, app version
 * and the legal links.
 *
 * Ported from managed-care-ui's Layout/Versions. Everything is supplied by the
 * controller — the logo comes from portal's sprockets asset, the copyright and
 * link labels from I18n, and the Osano cookie-preferences trigger is only passed
 * in where Osano is actually loaded.
 *
 * Uses plain anchors rather than the KeyDS Link component: these are small
 * inverted-on-dark links, and KeyDS Link brings its own colour and border
 * treatment that would have to be overridden anyway.
 */
function Versions({
  copyright,
  cookiePreferencesLabel,
  links,
  logoAlt,
  logoHref,
  logoSrc,
  version,
}) {
  const showCookiePreferences = Boolean(cookiePreferencesLabel);

  const openCookiePreferences = () => {
    // Osano is only loaded in production; the label is omitted elsewhere, so
    // this handler is never reachable without it.
    if (window.Osano) {
      window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
    }
  };

  return (
    <Container>
      {logoSrc && (
        <LogoContainer href={logoHref}>
          <Logo alt={logoAlt} src={logoSrc} />
        </LogoContainer>
      )}
      <TextContainer>
        <p>{copyright}</p>
        {version && <p>{version}</p>}
      </TextContainer>
      <Links>
        {links.map((link, index) => (
          <React.Fragment key={link.url}>
            {index > 0 && <span aria-hidden="true">|</span>}
            <a href={link.url} target="_blank" rel="noopener noreferrer">
              {link.label}
            </a>
          </React.Fragment>
        ))}
        {showCookiePreferences && (
          <>
            {links.length > 0 && <span aria-hidden="true">|</span>}
            <button type="button" onClick={openCookiePreferences}>
              {cookiePreferencesLabel}
            </button>
          </>
        )}
      </Links>
    </Container>
  );
}

Versions.propTypes = {
  cookiePreferencesLabel: PropTypes.string,
  copyright: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
  logoAlt: PropTypes.string,
  logoHref: PropTypes.string,
  logoSrc: PropTypes.string,
  version: PropTypes.string,
};

Versions.defaultProps = {
  cookiePreferencesLabel: undefined,
  links: [],
  logoAlt: 'Decisiv',
  logoHref: 'https://www.decisiv.com/',
  logoSrc: undefined,
  version: undefined,
};

export default Versions;
